module.exports = __webpack_public_path__ + "static/img/10.05eaa6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qie/10.png
// module id = 107
// module chunks = 1